module.exports = __webpack_public_path__ + "img/metal_x@2x.3efb3627.png";